module.exports = __webpack_public_path__ + "common/icon-product-contact-7945742b3a2cb6f09ce07dfc097d4443.svg";